import Form from "react-bootstrap/Form";
import React from "react";

export const FormControlTags = ({onChange, multiple = true, ...otherProps}) => {
  const update = e => {
    const tags = e.target.value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/[^0-9a-zA-Z\s]/g, "")
      .toLowerCase()
      .replace(/\s\s+/g, " ");

    const regex = multiple ? /^[0-9a-zA-Z\s]*$/ : /^[0-9a-zA-Z]*$/;

    if (!regex.test(tags)) {
      return;
    }

    e.target.value = tags;

    onChange(e);
  };

  return <Form.Control type="text" onChange={update} {...otherProps}/>;
};
